import { heroStats } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20composition%20with%20deep%20warm%20red%20and%20dark%20tones%2C%20film%20reel%20silhouettes%20and%20soft%20bokeh%20lights%2C%20elegant%20movie%20theater%20atmosphere%2C%20artistic%20curved%20film%20strip%20lines%2C%20dark%20gradient%20background%20with%20warm%20highlights%2C%20modern%20minimalist%20cinema%20aesthetic%2C%20high%20end%20visual%20design&width=1400&height=900&seq=hero-main-cq&orientation=landscape"
          alt="成全影院高清在线观影平台主视觉"
          className="w-full h-full object-cover object-top"
          onError={(e) => { const t = e.currentTarget; t.style.display = 'none'; }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-500/20 text-primary-300 text-xs font-medium tracking-wide mb-4 whitespace-nowrap">
              高清 · 流畅 · 无广告
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-white leading-tight mb-4">
              成全影院 - 高清画质免费在线观影平台
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-heading mb-6">
              蓝光画质不卡顿，沉浸式追剧新体验
            </p>

            <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-xl lg:max-w-none mb-8">
              成全影院是专注于高清画质在线观影的平台，收录超过两万部电影和电视剧全集，覆盖动作、喜剧、悬疑、爱情、科幻等全品类内容。平台采用分布式CDN加速与智能码率自适应技术，无论宽带还是移动网络，都能享受流畅不卡顿的蓝光观影体验。内容团队每日更新资源，院线新片下映后第一时间上线高清版本，热门电视剧同步跟播，全程无广告干扰，免费在线观看。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-white/60 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-md font-medium text-sm whitespace-nowrap cursor-pointer transition-colors duration-200"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/20 text-white border border-white/30 rounded-md font-medium text-sm whitespace-nowrap cursor-pointer transition-colors duration-200"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20composition%20with%20warm%20red%20and%20gold%20tones%2C%20film%20reel%20silhouettes%2C%20soft%20bokeh%20lights%2C%20elegant%20movie%20theater%20atmosphere%2C%20artistic%20film%20strip%20curves%2C%20dark%20gradient%20background%20with%20warm%20highlights%2C%20modern%20minimalist%20cinema%20aesthetic&width=800&height=600&seq=hero-visual-cq&orientation=landscape"
                alt="成全影院沉浸式观影体验"
                className="w-full h-full object-cover"
                onError={(e) => { const t = e.currentTarget; const p = t.parentElement; if (p) p.style.display = 'none'; }}
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}